import { StyleSheet } from 'react-native';
import colors, { appTheme } from '@/config/colors';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  fullHeight: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    paddingVertical: theme.spacings.sm,
    width: '100%',
  },
  cardContainer: {
    backgroundColor: colors.white,
    borderColor: colors.mediumGrey,
    borderRadius: 10,
    borderWidth: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    marginBottom: theme.spacings.lg,
    overflow: 'hidden',
  },
  cardSection: {
    paddingHorizontal: theme.spacings.lg,
    paddingVertical: theme.spacings.md,
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  heading: {
    fontSize: 16,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  headingRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  hintRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  rowBetween: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  rowTextContainer: {
    flex: 1,
    paddingRight: theme.spacings.md,
  },
  textBold: {
    fontWeight: 'bold',
  },
  statusPill: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
    borderWidth: 1,
    borderColor: appTheme.primary,
    borderRadius: 16,
    paddingVertical: theme.spacings.xs,
    paddingHorizontal: theme.spacings.sm,
    marginTop: theme.spacings.xs,
  },
  statusPillText: {
    color: appTheme.primary,
    fontWeight: 'bold',
  },
  infoBanner: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: colors.newUI.therapist.green10,
    paddingHorizontal: theme.spacings.lg,
    paddingVertical: theme.spacings.md,
  },
  infoBannerText: {
    flex: 1,
    color: colors.newUI.therapist.green70,
  },
  warningBanner: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: colors.newUI.therapist.yellow10,
    paddingHorizontal: 24,
    paddingVertical: 16,
  },
  warningBannerText: {
    flex: 1,
    color: colors.newUI.therapist.orange90,
  },
  headingIcon: {
    marginRight: theme.spacings.sm,
  },
  text: {
    fontSize: 16,
  },
  textSmall: {
    fontSize: 14,
    color: colors.darkGrey,
  },
  textCenter: {
    textAlign: 'center',
  },
});
